import {SxProps, Theme, Breadcrumbs as MuiBreadcrumbs} from "@mui/material";
import {NavLink} from "react-router-dom";

import {IBreadcrumbItem} from "~/components/breadcrumbs";

import {styles} from "./Breadcrumbs.styles";

export interface BmBreadcrumbsProps {
  sx?: SxProps<Theme>;
  breadcrumbs: IBreadcrumbItem[];
}

export const BmBreadcrumbs: React.FC<BmBreadcrumbsProps> = ({sx, breadcrumbs}) => {
  return (
    <MuiBreadcrumbs separator="›" aria-label="breadcrumb" className={styles.breadcrumbs} sx={sx}>
      {breadcrumbs.map((breadcrumb, index) =>
        breadcrumb.to ? (
          <NavLink
            key={index}
            to={breadcrumb.to}
            className={({isActive}) => `${styles.breadcrumb} ${isActive ? styles.active : ""}`}
            end
          >
            {breadcrumb.title}
          </NavLink>
        ) : (
          <span key={index} className={styles.breadcrumb}>
            {breadcrumb.title}
          </span>
        ),
      )}
    </MuiBreadcrumbs>
  );
};
